import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Data Dreaming', 
  description = 'Where data meets creativity. AI workshops, events, and community.',
  image = 'https://customer-assets.emergentagent.com/job_caf6c523-32ed-44de-aaab-8552e94ae126/artifacts/d7ltuzdn_datadreaminglogowhite.png',
  url,
  type = 'website'
}) => {
  const siteUrl = 'https://datadreaming.cloud';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
